import React from "react";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/* Shown when a verified Google account is not on the server-side owner allowlist.
   The server already rejects every API call with 403 — this is only the plain explanation. */
export default function Denied({ message }) {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen hud-bg flex items-center justify-center p-6" data-testid="access-denied">
      <div className="panel p-8 max-w-md text-center">
        <ShieldAlert size={28} className="text-amber-300 mx-auto mb-4" />
        <div className="label-eyebrow mb-2">JARVIS · MODIHOME</div>
        <h1 className="text-base md:text-lg text-white/90 mb-3">Bu hesap yetkili değil</h1>
        <p className="text-sm text-white/60" data-testid="access-denied-message">
          {message || "Bu JARVIS kurulumu özel bir asistandır; bu hesap yetkili değil."}
        </p>
        <button onClick={logout} data-testid="access-denied-logout-btn"
          className="mt-6 px-5 py-2.5 rounded-full bg-white/5 border border-white/15 text-white/80 hover:bg-white/10 text-sm">
          Çıkış yap ve girişe dön
        </button>
      </div>
    </div>
  );
}
